module.exports = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");